const CalendarReferenceDateYear = 2022;
const CalendarReferenceDateMonth = 1;
const CalendarReferenceDateDay = 2;
const CalendarReferenceDate = toDateStr(CalendarReferenceDateYear, CalendarReferenceDateMonth, CalendarReferenceDateDay);

let ScheduleTypeColors = null;

function getScheduleTypeColors() {
    if (ScheduleTypeColors === null) {
        ScheduleTypeColors = {
            sleep: $('.indicator-sleep').getBackgroundColor(),
            gettingReady: $('.indicator-getting-ready').getBackgroundColor(),
            work: $('.indicator-work').getBackgroundColor(),
            commuting: $('.indicator-commuting').getBackgroundColor(),
            family: $('.indicator-family').getBackgroundColor(),
            study: $('.indicator-study').getBackgroundColor(),
            lifestyle: $('.indicator-lifestyle-10').getBackgroundColor(),
            other: $('.indicator-other').getBackgroundColor(),
        };
    }
    return ScheduleTypeColors;
}


class ScheduleCalendarView {

    constructor(onEventChangeFn,
                onEventAddFn) {
        this.rootNode = $('.calendar');
        this.calendar = new FullCalendar.Calendar(this.rootNode[0], {
            initialView: 'timeGridWeek',
            nowIndicator: false,
            headerToolbar: false,
            themeSystem: 'bootstrap5',
            dayHeaderFormat: {weekday: 'long'},
            allDaySlot: false,
            displayEventTime: false,
            initialDate: CalendarReferenceDate,
            editable: true,
            eventOverlap: false,
            eventChange: onEventChangeFn,
            eventContent: function (data) {
                let event = data.event;
                return {
                    html: '<div class="fc-event-main-frame '+event.classNames+'"><div class="fc-event-title-container">' +
                        '<div class="fc-event-title fc-sticky">' + event.title + '</div>' +
                        '<a class="close" data-event-id="'+event.id+'"><i class="icon-close"></i></a>' +
                        '</div></div>'
                };
            },
            selectable: true,
            select: function(selectionInfo) {
                onEventAddFn(selectionInfo.start, selectionInfo.end);
            }
        });
        this.calendar.render();
    }

    setStartEndHours(start, end) {
        this.calendar.setOption('slotMinTime', start + ':00:00');
        this.calendar.setOption('slotMaxTime', end + ':00:00');
    }

    clearCalendar() {
        let listEvent = this.calendar.getEvents();
        listEvent.forEach(event => event.remove());
    }

    getEventColor(scheduleItem) {
        switch (scheduleItem.getType()) {
            case ScheduleType.sleep:
                return getScheduleTypeColors().sleep;
            case ScheduleType.gettingReady:
                return getScheduleTypeColors().gettingReady;
            case ScheduleType.workOffice:
                return getScheduleTypeColors().work;
            case ScheduleType.workHome:
                return getScheduleTypeColors().work;
            case ScheduleType.commuting:
                return getScheduleTypeColors().commuting;
            case ScheduleType.family:
                return getScheduleTypeColors().family;
            case ScheduleType.study:
                return getScheduleTypeColors().study;
            case ScheduleType.lifestyle:
                return getScheduleTypeColors().lifestyle;
            case ScheduleType.other:
                return getScheduleTypeColors().other;
        }

        return '#000';
    }

    getEventTitle(scheduleItem) {
        switch (scheduleItem.getType()) {
            case ScheduleType.gettingReady:
                return 'Getting ready';
            case ScheduleType.workOffice:
                return 'Work at office';
            case ScheduleType.workHome:
                return 'Work from office';
            case ScheduleType.commuting:
                return 'Commuting';
            case ScheduleType.family:
                return 'Family';
            case ScheduleType.study:
                return 'Study';
            case ScheduleType.lifestyle:
                return this.getLifestyleEventTitle(scheduleItem);
            case ScheduleType.other:
                return scheduleItem.getName();
        }
        return ''
    }

    getLifestyleEventTitle(scheduleItem) {
        let lifestyleNo = scheduleItem.getLifestyleNo();
        let lifestyleActivity = plannerApplication.studyPlannerProfile.getLifestyle().getActivities().at(lifestyleNo);
        return lifestyleActivity.getName();
    }
}
